{
  "core_fields": {
    "first_name": "名字",
    "last_name": "姓氏",
    "nick_name": "昵称",
    "full_name": "全名",
    "role": "角色",
    "import_id": "导入ID",
    "contact_type": "联系人类型",
    "resource_type_id": "资源类型",
    "represented_by_id": "代表",
    "profile_picture": "头像",
    "rates": "费率",
    "tags": "标签",
    "groups": "群组",
    "locations": "地点",
    "emails": "电子邮件",
    "websites": "网站",
    "phone_numbers": "电话号码",
    "socials": "社交",
    "pronouns": "代词",
    "code": "代码",
    "icon": "图标",
    "title": "标题",
    "production_type_id": "制作类型",
    "production_template_id": "制作模板",
    "production_date": "制作日期",
    "shotflow_instance": "Shotflow实例",
    "status_id": "状态",
    "description": "描述",
    "color": "颜色",
    "timezone": "时区",
    "events": "日程",
    "production_locations": "地点",
    "budget_amount": "预算金额",
    "estimated_total": "预计总额",
    "actual_total": "实际总额",
    "budget_expenses": "预算费用",
    "budget_expenses.name": "名称",
    "budget_expenses.description": "描述",
    "budget_expenses.estimate": "预估",
    "budget_expenses.archived": "已存档",
    "budget_expenses.group_id": "分组",
    "budget_expenses.slot_category_id": "类别",
    "budget_expenses.expenses": "费用",
    "budget_expenses.expenses.booking_id": "预订",
    "budget_expenses.expenses.booking.resource_id": "资源",
    "budget_expenses.expenses.commit_vendor": "供应商",
    "budget_expenses.expenses.commit": "已承诺",
    "budget_expenses.expenses.created_at": "创建于",
    "budget_expenses.expenses.updated_at": "更新于",
    "budget_expenses.expenses.slot_category_id": "类别",
    "budget_expenses.expenses.receipts": "收据",
    "resourcing_at": "资源分配于",
    "ready_at": "准备于",
    "completed_at": "完成于",
    "cancelled_at": "取消于",
    "booking_type_id": "预订类型",
    "rate": "费率",
    "note": "备注",
    "contracts": "合同",
    "invoices": "发票",
    "submitted_date": "提交日期",
    "agreed_date": "同意日期",
    "pencilled_at": "草拟于",
    "confirmed_at": "确认于",
    "createdAt": "创建于",
    "updatedAt": "更新于",
    "archived": "已存档",
    "user_id": "所有者",
    "bookings": "预订",
    "public_id": "公开ID",
    "status": "状态",
    "public_title": "公开标题",
    "public_description": "公开描述",
    "confirmation_text": "确认文本",
    "enable_notifications": "启用通知",
    "published": "已发布",
    "deadline": "截止日期",
    "public": "公开",
    "expanded": "已展开",
    "public_feedback": "公众评价",
    "layout": "布局",
    "enable_voting": "启用投票",
    "enable_commenting": "启用评论",
    "billing": "账单",
    "social": "社交",
    "hard_drive": "硬盘",
    "from_date": "起始日期",
    "to_date": "结束日期",
    "call_time": "呼叫时间",
    "resource_slots": "资源时段",
    "resource": "资源",
    "resource_slot_assignments": "资源时段分配",
    "organisation": "组织",
    "organisation_id": "组织",
    "availability": "可用性",
    "all": "全部",
    "published_at": "发布时间",
    "callsheet_date": "呼叫日期"
  },
  "rate_intervals": {
    "DAILY": "每日",
    "HOURLY": "每小时",
    "FIXED": "固定",
    "ITEM": "每项"
  },
  "rateInput": {
    "currencyAria": "货币",
    "amountAria": "费率金额",
    "intervalAria": "计费单位",
    "quantityAria": "数量",
    "currencyTooltip": "此费率使用的货币。",
    "amountTooltip": "费率金额（不含数量与附加费用）。",
    "intervalTooltip": "计费方式，例如按小时或按天。",
    "multiplyTooltip": "费率乘以数量得到行合计。",
    "quantityTooltip": "适用此费率的单位数量。"
  },
  "rateEditor": {
    "name": "名称",
    "namePlaceholder": "例如：日费率",
    "amount": "金额",
    "amountPlaceholder": "0.00",
    "currency": "货币",
    "billingUnit": "计费单位",
    "fees": "附加费用",
    "feesHint": "金额的百分比",
    "note": "备注",
    "optional": "可选",
    "notePlaceholder": "条款、包含内容、条件",
    "noAmount": "无金额",
    "unnamed": "未命名费率",
    "fee": {
      "agency": "代理",
      "payroll": "薪酬",
      "processing": "处理"
    },
    "feeFull": {
      "agency": "代理费",
      "payroll": "薪酬费",
      "processing": "处理费"
    },
    "feeSummary": "+{{percent}}% {{fee}}",
    "feeSpoken": "{{percent}}% {{fee}}",
    "plusFees": "另加 {{fees}}",
    "unit": {
      "DAILY": "/ 天",
      "HOURLY": "/ 小时",
      "FIXED": "固定",
      "ITEM": "/ 项"
    },
    "unitSpoken": {
      "DAILY": "每天",
      "HOURLY": "每小时",
      "FIXED": "固定费用",
      "ITEM": "每项"
    },
    "unitOption": {
      "DAILY": "按天",
      "HOURLY": "按小时",
      "FIXED": "固定费用",
      "ITEM": "按项"
    },
    "autoName": {
      "DAILY": "日费率",
      "HOURLY": "小时费率",
      "FIXED": "固定费用",
      "ITEM": "单项费率"
    },
    "withFees": "含费用",
    "howCalculated": "明细",
    "breakdown": {
      "rate": "费率",
      "agency": "代理费 {{percent}}%（按费率）",
      "payroll": "薪酬费 {{percent}}%（按 {{base}}，即费率减代理费）",
      "processing": "处理费 {{percent}}%（按 {{base}}，即小计）",
      "total": "含费用"
    },
    "rateCard": "费率卡",
    "rateCardHint": "在“设置 › 费率卡”中管理。费率卡的更改会同步到这里。",
    "detachAndEdit": "解除关联并编辑",
    "manageRateCards": "管理费率卡",
    "rateCardUnavailable": "不可用",
    "rateCardUnavailableHint": "此费率卡已归档或你无权查看。请移除或替换为当前的费率卡。",
    "rateCardFallbackName": "费率卡 #{{id}}",
    "errors": {
      "nameRequired": "请输入名称，例如：日费率。",
      "amountRequired": "请输入金额。",
      "currencyRequired": "请选择币种。",
      "amountInvalid": "请输入数字，例如 850 或 850.50。",
      "amountNegative": "金额不能为负数。",
      "amountDecimals": "最多保留 {{digits}} 位小数。",
      "amountNoDecimals": "{{currency}} 金额不能有小数。",
      "feeRange": "{{fee}}：请输入 0 到 100 之间的整数。",
      "unitUnsupported": "请选择按天、按小时或固定费用。",
      "amountTooLarge": "请输入不超过 {{max}} 的金额。"
    }
  },
  "validation": {
    "required": "此字段为必填项",
    "url": "链接无效",
    "email": "电子邮件地址无效",
    "phone_number": "电话号码无效"
  },
  "standard-date-filter": {
    "timestamp": {
      "last7Days": "最近7天",
      "last30Days": "最近30天",
      "last90Days": "最近90天"
    },
    "scheduled": {
      "today": "今天",
      "tomorrow": "明天",
      "nextWeek": "下周",
      "nextMonth": "下个月"
    },
    "custom": {
      "last7Days": "最近7天",
      "last30Days": "最近30天",
      "last90Days": "最近90天",
      "today": "今天",
      "tomorrow": "明天",
      "nextWeek": "下周",
      "nextMonth": "下个月"
    }
  },
  "AccountSettingsPronouns": {
    "sectionLabel": "资源",
    "title": "代词选项",
    "description": "配置编辑人员（个人、达人、经纪人）时可用的代词标签。",
    "listTitle": "允许的代词",
    "help": "保存资源时会校验这些值。拖动手柄可调整顺序；保存时会去除重复项。",
    "dragHandleLabel": "拖动以排序",
    "optionPlaceholder": "例如：They/Them",
    "addOption": "添加选项",
    "remove": "移除",
    "save": "保存",
    "saved": "代词选项已保存",
    "saveFailed": "无法保存代词选项"
  },
  "online_status": {
    "online": "您已在线",
    "offline": "您已离线",
    "toast_offline": "您已离线",
    "toast_online": "您已重新上线"
  },
  "enterprise": {
    "globalScopeLabel": "全局",
    "tags": "标签",
    "rateCards": "费率卡",
    "expenseTypes": "费用类型",
    "slotCategories": "槽位类别",
    "loadingWorkspaces": "正在加载工作区…",
    "workspacesUnavailable": "工作区不可用",
    "workspacesUnavailableHint": "请尝试刷新页面。",
    "emptyWorkspaces": "没有可用的工作区",
    "emptyWorkspacesHint": "正常情况下不应出现。如看到此提示，请联系支持。",
    "teamsSectionLabel": "团队",
    "loadingTeams": "正在加载团队…",
    "teamsUnavailable": "团队不可用",
    "emptyTeams": "此工作区中没有团队",
    "emptyTeamsHint": "正常情况下不应出现。如看到此提示，请联系支持。",
    "teamsSettingsLabel": "团队设置",
    "newTeam": "新建团队",
    "newWorkspace": "新建工作区",
    "switchWorkspace": "切换工作区",
    "createWorkspace": "创建工作区",
    "createWorkspaceDescription": "为组织添加新的企业工作区。",
    "editWorkspace": "编辑工作区",
    "editWorkspaceDescription": "更新工作区名称和图标。",
    "createTeam": "创建团队",
    "createTeamDescription": "在此工作区下添加新团队。",
    "editTeam": "编辑团队",
    "editTeamDescription": "更新团队名称、图标和颜色。",
    "archive": "归档",
    "unarchive": "恢复",
    "activeTab": "活跃",
    "archivedTab": "已归档",
    "emptyArchivedWorkspaces": "没有已归档的工作区",
    "emptyArchivedTeams": "此工作区中没有已归档的团队",
    "edit": "编辑",
    "create": "创建",
    "save": "保存",
    "fieldName": "名称",
    "fieldIcon": "图标",
    "fieldIconColor": "图标颜色",
    "pickIconColor": "选择颜色",
    "manageEntity": "管理",
    "manageEnterprise": "管理企业",
    "visitorManagement": "访客管理",
    "organizationTalents": "组织人才",
    "manageEnterpriseDescription": "在组织中创建、编辑和归档工作区与团队。",
    "workspacesTitle": "工作区",
    "teamsTitle": "团队",
    "teamsForWorkspace": "{{workspace}} 中的团队",
    "selectWorkspaceHint": "选择一个工作区以管理其团队",
    "teamDashboard": "仪表板"
  },
  "bookingConfirmationSettings": {
    "title": "预订确认模板",
    "description": "为此工作区配置预订确认电子邮件模板。",
    "templatePlaceholder": "编写确认电子邮件正文…",
    "insertPlaceholder": "插入区块",
    "insertPlaceholderMenuLabel": "字段",
    "insertPlaceholderSectionsLabel": "区块",
    "hints": {
      "first_name": "资源的名字",
      "full_name": "资源的全名",
      "booking_status": "当前预订状态",
      "booking_role": "此预订中的角色",
      "production_title": "制作标题",
      "booking_estimated_total": "预订预估总费用",
      "booking_note": "预订备注",
      "section": {
        "booking_events": "按每个预订日期或时间重复",
        "booking_estimated_total": "仅在设置了总额时包含",
        "booking_note": "仅在设置了备注时包含"
      }
    },
    "frameTitle": "模板编辑器",
    "previewLabel": "预览",
    "viewModeEditor": "代码",
    "viewModePreview": "预览",
    "viewModeSplit": "分栏",
    "emptyTip": "发送预订确认需要非空模板。",
    "save": "保存",
    "cancel": "取消",
    "saveSuccess": "预订确认模板已更新",
    "saveFailed": "无法更新预订确认模板",
    "loadFailed": "无法加载预订确认模板",
    "missingWorkspace": "请从工作区打开此页面以编辑其确认模板。"
  },
  "workspaceGeneralSettings": {
    "title": "常规",
    "description": "管理此工作区的常规设置",
    "missingWorkspace": "请从工作区打开此页面以编辑其常规设置。",
    "brandImage": {
      "title": "品牌图片",
      "description": "应用中暂未使用。",
      "fieldLabel": "品牌图片"
    },
    "defaultCurrency": {
      "title": "默认货币",
      "description": "当新的制作、费率或支出未指定货币时使用。",
      "fieldLabel": "货币"
    },
    "defaultLocale": {
      "title": "语言",
      "description": "此工作区的公开页面和发送邮件所使用的语言。",
      "fieldLabel": "语言"
    },
    "defaultCountryCode": {
      "title": "本地化",
      "description": "输入国内电话号码时的默认国家/地区。",
      "fieldLabel": "国家/地区"
    },
    "saveSuccess": "设置已更新",
    "saveFailed": "更新设置失败",
    "loadFailed": "无法加载设置",
    "defaultTimezone": {
      "title": "时区",
      "description": "此工作区中日程、活动和通告单的默认时区。",
      "fieldLabel": "时区"
    },
    "roleMissingDays": {
      "title": "制作提醒",
      "description": "在此天数内开始的开放或配置中的制作将被标记为有风险。",
      "fieldLabel": "拍摄前提醒",
      "unit": "天"
    },
    "tagsFixed": {
      "title": "标签",
      "description": "标签在所有工作区之间共享。开启固定标签后，此工作区的成员在编辑资源时只能选择现有标签，不能创建新标签。新标签在全局标签设置中添加。",
      "fieldLabel": "固定标签"
    }
  },
  "publicProfileSettings": {
    "title": "公开资料",
    "description": "设置已发布页面的品牌外观。",
    "sections": {
      "brandImage": "品牌图片",
      "names": "名称",
      "brandColors": "品牌颜色"
    },
    "fields": {
      "organizationName": "组织名称",
      "organizationNamePlaceholder": "公司",
      "teamName": "团队名称",
      "teamNamePlaceholder": "团队",
      "backgroundColour": "背景色",
      "primaryColour": "主色",
      "secondaryColour": "次色",
      "pickColour": "选择颜色"
    },
    "frameTitle": "品牌",
    "viewModeEditor": "设置",
    "viewModePreview": "预览",
    "viewModeSplit": "分栏",
    "previewLabel": "分享品牌预览",
    "previewHint": "公开征集、电子邮件和候选名单的大致外观。非像素级精确。",
    "previewCalloutTitle": "公开征集",
    "previewEmailTitle": "电子邮件页眉",
    "previewShortlistTitle": "公开候选名单",
    "previewSampleCompany": "您的组织",
    "previewSampleTeam": "您的团队",
    "previewSampleCalloutTitle": "人才公开征集",
    "previewSampleCalloutDescription": "申请人在此页面看到您的徽标和颜色。",
    "previewSampleCta": "立即申请",
    "previewSampleEmailSubject": "预订更新",
    "previewSampleEmailBody": "你好 Alex，你收到来自 {{team}} 的更新。",
    "previewSampleShortlistTitle": "春季活动候选名单",
    "previewSampleShortlistBadge": "已与客户分享",
    "save": "保存",
    "cancel": "取消",
    "saveSuccess": "公开资料已更新",
    "saveFailed": "无法更新公开资料",
    "loadFailed": "无法加载公开资料设置",
    "missingTeam": "请从团队打开此页面以编辑其公开资料。"
  },
  "resourceTypesAdmin": {
    "globalTitle": "资源类型",
    "globalDescription": "管理在所有工作区间同步的系统级资源类型。",
    "workspaceTitle": "资源类型",
    "workspaceDescription": "管理此工作区中可见的资源类型并管理工作区专属字段。",
    "name": "名称",
    "type": "类型",
    "workspaces": "工作区",
    "assignWorkspaces": "管理工作区",
    "searchWorkspaces": "搜索工作区…",
    "openInWorkspace": "打开 {{workspace}} 设置",
    "workspacesTabHint": "资源类型默认不分配到工作区。请在需要显示的工作区中启用它们。",
    "workspacesSearchNoResults": "未找到工作区",
    "workspacesTabEmpty": "此组织中还没有工作区",
    "workspacesLoadError": "无法加载工作区",
    "newResourceType": "新建资源类型",
    "createTitle": "创建资源类型",
    "createDescription": "创建可在整个组织中使用的资源类型。",
    "fieldName": "名称",
    "fieldIcon": "图标",
    "fieldMechanism": "类型",
    "mechanismLockedHint": "创建后无法编辑。",
    "chooseIcon": "选择图标",
    "active": "启用",
    "inactive": "停用",
    "activate": "启用",
    "deactivate": "停用",
    "activateFieldTitle": "启用字段？",
    "activateFieldDescription": "确定要启用此字段吗？",
    "deactivateFieldTitle": "停用字段？",
    "deactivateFieldDescription": "确定要停用此字段吗？您不会丢失任何数据。",
    "edit": "编辑",
    "archive": "归档",
    "unarchive": "恢复",
    "archiveSuccess": "资源类型已归档",
    "unarchiveSuccess": "资源类型已恢复",
    "enable": "在工作区中启用",
    "disable": "在工作区中停用",
    "enableSuccess": "资源类型已在工作区中启用",
    "disableSuccess": "资源类型已在工作区中停用",
    "disabledInWorkspaceTitle": "此资源类型在 {{workspace}} 中已停用",
    "disabledInWorkspaceDescription": "在启用之前，此工作区的成员将看不到此类型的资源。",
    "disableConfirmTitle": "停用资源类型？",
    "disableConfirmDescription": "所选资源类型将不再显示在此工作区中。您不会丢失任何数据。",
    "detailsTab": "详情",
    "detailsSaveSuccess": "资源类型已保存",
    "detailsSaveFailed": "无法保存资源类型",
    "fieldsTab": "字段",
    "globalDetailSubtitle": "为所有工作区编辑此资源类型。",
    "workspaceDetailSubtitle": "编辑此资源类型的工作区专属选项。若要编辑更多内容，请前往全局资源类型页面。",
    "viewGlobalSettings": "查看全局设置",
    "viewGlobalResourceTypes": "查看全局资源类型",
    "globalFieldsTitle": "全局字段",
    "globalFieldsHint": "在此编辑和添加的字段将应用于所有工作区。若要编辑工作区专属字段，请前往工作区设置。",
    "workspaceGlobalFieldsHint": "全局字段只能在工作区之外的全局配置中编辑。",
    "configureGlobalFields": "配置全局字段",
    "workspaceFieldsTitle": "{{workspace}} 字段",
    "workspaceFallbackName": "工作区",
    "required": "必填",
    "locked": "已锁定",
    "filterable": "可筛选",
    "requiredEnabledToast": "字段已标记为必填",
    "requiredDisabledToast": "字段不再必填",
    "filterableEnabledToast": "字段现在可筛选",
    "filterableDisabledToast": "字段不再可筛选",
    "fieldPropertyUpdateError": "无法更新字段",
    "fieldType": "类型",
    "addField": "添加字段",
    "addFieldAssignPrompt": "将添加到",
    "searchFields": "搜索字段…",
    "fieldsSearchNoResults": "未找到字段",
    "dangerousActions": "危险操作",
    "archiveSectionTitle": "归档资源类型",
    "archiveSectionDescription": "数据将被保留，但所有工作区的用户将不再看到此资源类型",
    "unarchiveSectionTitle": "恢复资源类型",
    "unarchiveSectionDescription": "恢复此资源类型，以便可以再次在工作区中启用。",
    "entityNameSingular": "资源类型",
    "entityNamePlural": "资源类型",
    "fieldEntityNameSingular": "字段",
    "fieldEntityNamePlural": "字段",
    "batchArchiveSelected": "归档所选",
    "batchUnarchiveSelected": "恢复所选",
    "batchActivateSelected": "启用所选",
    "batchDeactivateSelected": "停用所选",
    "batchActivateFieldsNone": "没有可启用的字段",
    "batchDeactivateFieldsNone": "锁定的系统字段无法停用",
    "batchEnableSelected": "启用所选",
    "batchDisableSelected": "停用所选",
    "reorderFields": "调整字段顺序",
    "emptyActive": "没有启用的资源类型",
    "emptyInactive": "没有停用的资源类型",
    "emptyArchived": "没有已归档的资源类型",
    "emptyFields": "暂无字段",
    "emptyInactiveFields": "没有停用的字段",
    "loadError": "无法加载此资源类型",
    "localPreviewNote": "在后端支持之前，工作区启用状态和字段仅保存在此浏览器本地。",
    "assignResourceTypesAction": "启用资源类型",
    "assignResourceTypesTitle": "启用资源类型",
    "assignResourceTypesSearchPlaceholder": "搜索资源类型…",
    "assignResourceTypesSelectedCount": "已选择 {{count}} 项",
    "assignResourceTypesSelectPrompt": "选择要在此工作区中启用的资源类型",
    "assignResourceTypesUnselectAll": "取消全选",
    "assignResourceTypesEmpty": "所有资源类型均已在此工作区中启用",
    "assignResourceTypesNoResults": "未找到资源类型",
    "assignResourceTypesConfirm": "启用（{{count}}）",
    "assignResourceTypesLoadError": "无法加载资源类型",
    "create": "创建",
    "createFailed": "无法创建资源类型",
    "unsavedChangesBeforeUnload": "您有未保存的更改！",
    "cancel": "取消",
    "mechanisms": {
      "INDIVIDUAL": "个人",
      "ORGANIZATION": "组织",
      "LOCATION": "地点",
      "ITEM": "物品",
      "TALENT": "人才",
      "AGENT": "经纪人"
    }
  },
  "app_update": {
    "message": "应用有新版本可用。",
    "refresh": "刷新"
  },
  "app_crash": {
    "title": "出现问题",
    "description": "应用已崩溃。请刷新后重试，或联系我们获取帮助",
    "refresh": "刷新",
    "goToDashboard": "前往仪表板",
    "errorLogLabel": "错误详情"
  },
  "server_unreachable": {
    "bootstrap": {
      "title": "无法加载应用",
      "description_connection": "无法连接到服务器。请检查网络连接并刷新。",
      "description_server": "加载必要数据时服务器返回错误。请稍后再试。"
    },
    "session": {
      "title": "无法加载会话",
      "description_connection": "无法连接服务器以加载账户设置。请检查网络连接并刷新。",
      "description_server": "由于服务器错误，无法加载账户设置。请稍后再试。"
    },
    "sign_in": {
      "title": "登录不可用",
      "description_connection": "无法连接以验证登录选项。请检查网络连接并刷新。",
      "description_server": "由于服务器错误，登录暂时不可用。请稍后再试。"
    },
    "refresh": "刷新",
    "goToDashboard": "前往仪表板",
    "errorLogLabel": "错误详情"
  },
  "not_found": {
    "title": "抱歉，我们找不到您要查找的内容",
    "description": "请检查链接是否正确，并确认您已登录。如果仍有问题，请联系我们！",
    "contactSupport": "联系支持",
    "goToDashboard": "前往仪表板",
    "workspace": {
      "title": "找不到工作区",
      "description": "此工作区可能已删除，或者链接不正确"
    },
    "team": {
      "title": "找不到团队",
      "description": "此团队可能已删除，或者链接不正确"
    },
    "contact": {
      "title": "找不到联系人",
      "description": "此联系人可能已归档，或者链接不正确"
    },
    "production": {
      "title": "找不到制作",
      "description": "此制作可能已归档，或者链接不正确"
    },
    "callout": {
      "title": "找不到征集",
      "description": "此征集可能已归档，或者链接不正确"
    },
    "callsheet": {
      "title": "找不到通告单",
      "description": "此通告单可能已归档，或者链接不正确"
    },
    "shortlist": {
      "title": "找不到短名单",
      "description": "此短名单可能已归档，或者链接不正确"
    }
  },
  "sandbox": {
    "badge": "沙盒",
    "title": "您正在使用沙盒环境",
    "subtitle": "安全地抢先体验即将推出的功能。",
    "isolated": {
      "title": "完全隔离",
      "description": "您在此处的任何操作都不会影响生产账户及其数据。"
    },
    "early_access": {
      "title": "抢先体验",
      "description": "新功能通常会比正式上线提前 1–2 周在此发布。"
    },
    "feedback": {
      "title": "帮助我们改进",
      "description": "发现问题或有好的想法？欢迎告诉我们。"
    },
    "send_feedback": "发送反馈",
    "dismiss": "知道了"
  },
  "commandBar": {
    "label": "搜索或创建",
    "onThisPage": "本页"
  },
  "settingsSidebar": {
    "backToApp": "返回应用"
  }
}
